import type { TFunction } from "i18next";


interface VoteListFooterProps {
  showBecomeMayor: boolean;
  isLoading: boolean;
  onBecomeMayor: () => void;
  onBack: () => void;
  t: TFunction;
}

/** "Become mayor" (when registration open) + Back under the candidate list. */
function VoteListFooter({
  showBecomeMayor,
  isLoading,
  onBecomeMayor,
  onBack,
  t,
}: VoteListFooterProps) {
  return (
    <>
      {/* Become mayor — reuses the same registerCandidate flow as the "register" screen */}
      {showBecomeMayor && (
        <div className="mt-md flex justify-end">
          <button
            onClick={() => onBecomeMayor()}
            disabled={isLoading}
            className="flex items-center justify-center rounded-pill border-none bg-[image:var(--gradient-gold-hot)] px-[36px] py-[10px] [font-family:'Rubik_One',sans-serif] text-[14px] font-normal text-object-picker-surface shadow-[0_2px_8px_var(--color-reward-warm-alpha-40)]"
            style={{
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {t("Become mayor")}
          </button>
        </div>
      )}

      {/* Back button */}
      <div className="mt-md flex justify-end">
        <button
          onClick={onBack}
          className="flex cursor-pointer items-center justify-center rounded-pill border-none bg-[image:var(--gradient-action-primary)] px-[36px] py-[10px] [font-family:'Rubik_One',sans-serif] text-[14px] font-normal text-white shadow-action-raised"
        >
          {t("Back")}
        </button>
      </div>
    </>
  );
}

export default VoteListFooter;
